import React, { useEffect } from 'react';

function EmailNewsletter() {
	return (
		<>
			<table className="body">
				<tbody>
					<tr>
						<td className="center" align="center" valign="top">
							<center>
								<table className="row header">
									<tbody>
										<tr>
											<td className="center" align="center">
												<center>
													<table className="container">
														<tbody>
															<tr>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td>
																					<a href="/dashboard/v4">
																						<img
																							src="/color-admin/admin/react/assets/img/logo/logo-admin.png"
																							height="24px"
																							alt="Color Admin logo"
																						/>
																					</a>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
																<td className="wrapper">
																	<table className="six columns">
																		<tbody>
																			<tr>
																				<td className="text-end valign-middle">
																					<a
																						href="#/"
																						style={{
																							lineHeight: '24px',
																							display: 'block',
																							color: '#333333'
																						}}
																					>
																						Follow Us
																					</a>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
															</tr>
														</tbody>
													</table>
												</center>
											</td>
										</tr>
									</tbody>
								</table>
								<table
									className="container content light-theme email-shell"
									width="580"
									style={{ width: '580px', background: '#ffffff' }}
									cellPadding="0"
									cellSpacing="0"
								>
									<tbody>
										<tr>
											<td>
												<table className="row">
													<tbody>
														<tr>
															<td className="hero-panel" style={{ padding: '30px' }}>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td>
																				<p
																					className="eyebrow"
																					style={{
																						fontSize: '10px',
																						fontWeight: 'bold',
																						letterSpacing: '1.5px',
																						textTransform: 'uppercase',
																						margin: '0 0 15px'
																					}}
																				>
																					Marketplace update
																				</p>
																				<h1
																					style={{
																						color: '#ffffff',
																						fontSize: '28px',
																						lineHeight: '32px',
																						fontWeight: 'bold',
																						margin: '0 0 10px'
																					}}
																				>
																					Fresh templates, faster launches
																				</h1>
																				<p
																					className="hero-copy"
																					style={{
																						color: '#d1d5db',
																						fontSize: '14px',
																						lineHeight: '20px',
																						margin: '0 0 15px'
																					}}
																				>
																					{' '}
																					Discover new WrapMarket templates
																					built for SaaS products, operations
																					tools, analytics dashboards, and
																					customer portals.{' '}
																				</p>
																				<table
																					width="100%"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td>
																								<a href="/dashboard/v1">
																									<img
																										src="/color-admin/admin/react/assets/img/mailbox/img-5.png"
																										alt="WrapMarket featured templates"
																										style={{
																											border: '0',
																											display:
																												'block'
																										}}
																									/>
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<p
																					className="hero-copy"
																					style={{
																						color: '#d1d5db',
																						fontSize: '14px',
																						lineHeight: '20px',
																						margin: '15px 0 15px'
																					}}
																				>
																					{' '}
																					Start with a polished foundation and
																					spend more time building the
																					features that matter.{' '}
																				</p>
																				<table
																					className="btn blue"
																					align="left"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									background:
																										'#0F83F0',
																									padding:
																										'10px 20px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#ffffff',
																										fontSize:
																											'13px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									Explore New Releases
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																			<td className="expander"></td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
												<table className="row">
													<tbody>
														<tr>
															<td
																className="email-section"
																style={{ padding: '30px 30px 15px' }}
															>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td width="300" style={{ width: '300px' }}>
																				<p
																					className="eyebrow"
																					style={{
																						fontSize: '10px',
																						fontWeight: 'bold',
																						letterSpacing: '1.5px',
																						textTransform: 'uppercase',
																						margin: '0 0 15px'
																					}}
																				>
																					Limited offer
																				</p>
																				<h4
																					style={{
																						color: '#2d353c',
																						fontSize: '20px',
																						lineHeight: '26px',
																						fontWeight: 'bold',
																						margin: '0 0 10px'
																					}}
																				>
																					Save 80% on featured templates
																				</h4>
																				<p
																					style={{
																						color: '#4b5563',
																						fontSize: '13px',
																						lineHeight: '20px',
																						margin: '0 0 12px'
																					}}
																				>
																					{' '}
																					Upgrade your toolkit with premium
																					themes, page variations, and starter
																					workflows from the WrapMarket
																					collection. This limited offer gives
																					your team a faster path from
																					prototype to production.{' '}
																				</p>
																				<ul
																					style={{
																						color: '#4b5563',
																						fontSize: '13px',
																						lineHeight: '20px',
																						margin: '0 0 16px',
																						paddingLeft: '18px'
																					}}
																				>
																					<li>
																						Multiple admin layouts for
																						different product needs
																					</li>
																					<li>
																						Responsive components built for
																						desktop and mobile
																					</li>
																					<li>
																						Dashboard, commerce, email,
																						profile, and utility pages
																					</li>
																					<li>
																						Light, dark, and branded theme
																						variations
																					</li>
																					<li>
																						Clean markup that is simple to
																						customize
																					</li>
																				</ul>
																				<table
																					className="btn blue"
																					align="left"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									padding: '9px 18px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#ffffff',
																										fontSize:
																											'13px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									View Offer
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																			<td
																				width="200"
																				style={{
																					width: '200px',
																					paddingLeft: '20px'
																				}}
																			>
																				<a href="/dashboard/v1">
																					<img
																						src="/color-admin/admin/react/assets/img/mailbox/img-7.png"
																						width="200"
																						alt="WrapMarket featured mobile template"
																						style={{
																							width: '200px',
																							maxWidth: '200px',
																							border: '0',
																							display: 'block',
																							margin: '15px 0'
																						}}
																					/>
																				</a>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
												<table className="divider"></table>
												<table className="row">
													<tbody>
														<tr>
															<td
																className="email-section"
																style={{ padding: '30px 30px 15px' }}
															>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td className="last">
																				<p
																					className="eyebrow"
																					style={{
																						fontSize: '10px',
																						fontWeight: 'bold',
																						letterSpacing: '1.5px',
																						textTransform: 'uppercase',
																						margin: '0 0 15px'
																					}}
																				>
																					Curated picks
																				</p>
																				<h4
																					style={{
																						color: '#2d353c',
																						fontSize: '22px',
																						lineHeight: '26px',
																						fontWeight: 'bold',
																						margin: '0 0 5px'
																					}}
																				>
																					More ways to ship polished
																					interfaces
																				</h4>
																				<p
																					style={{
																						color: '#4b5563',
																						fontSize: '13px',
																						lineHeight: '20px',
																						margin: '0 0 15px'
																					}}
																				>
																					{' '}
																					Explore focused add-ons for teams
																					that need better dashboards, cleaner
																					product workflows, and professional
																					email-ready screens without
																					designing every detail from
																					scratch.{' '}
																				</p>
																			</td>
																		</tr>
																	</tbody>
																</table>
																<table width="100%" cellPadding="0" cellSpacing="0">
																	<tbody>
																		<tr>
																			<td
																				width="140"
																				className="product-card"
																				style={{ width: '140px' }}
																			>
																				<a
																					href="/dashboard/v1"
																					style={{ display: 'block' }}
																				>
																					<img
																						src="/color-admin/admin/react/assets/img/mailbox/img-2.png"
																						width="100%"
																						alt="Dashboard kit preview"
																						style={{
																							width: '100%',
																							maxWidth: '100%',
																							border: '0',
																							display: 'block',
																							margin: '0 0 15px'
																						}}
																					/>
																				</a>
																				<h5
																					style={{
																						color: '#2d353c',
																						fontSize: '15px',
																						lineHeight: '21px',
																						fontWeight: 'bold',
																						margin: '0',
																						display: 'block'
																					}}
																				>
																					Dashboard Kit
																				</h5>
																				<p
																					style={{
																						color: '#4b5563',
																						fontSize: '12px',
																						lineHeight: '16px',
																						margin: '0 0 10px'
																					}}
																				>
																					Analytics cards, charts, tables, and
																					summary views for data-heavy
																					products.
																				</p>
																				<table
																					className="btn blue"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									background:
																																				'#0F83F0',
																									padding:
																																				'6px 12px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#ffffff',
																										fontSize:
																											'12px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									View Details
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																			<td
																				width="10"
																				style={{
																					width: '10px',
																					fontSize: '1px',
																					lineHeight: '1px'
																				}}
																			></td>
																			<td
																				width="140"
																				className="product-card"
																				style={{ width: '140px' }}
																			>
																				<a
																					href="/dashboard/v1"
																					style={{ display: 'block' }}
																				>
																					<img
																						src="/color-admin/admin/react/assets/img/mailbox/img-3.png"
																						width="100%"
																						alt="Commerce pages preview"
																						style={{
																							width: '100%',
																							maxWidth: '100%',
																							border: '0',
																							display: 'block',
																							margin: '0 0 15px'
																						}}
																					/>
																				</a>
																				<h5
																					style={{
																						color: '#2d353c',
																						fontSize: '15px',
																						lineHeight: '21px',
																						fontWeight: 'bold',
																						margin: '0',
																						display: 'block'
																					}}
																				>
																					Commerce Pages
																				</h5>
																				<p
																					style={{
																						color: '#4b5563',
																						fontSize: '12px',
																						lineHeight: '16px',
																						margin: '0 0 10px'
																					}}
																				>
																					Product, order, checkout, and
																					inventory screens for selling
																					workflows.
																				</p>
																				<table
																					className="btn blue"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									background:
																																				'#0F83F0',
																									padding:
																																				'6px 12px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#ffffff',
																										fontSize:
																											'12px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									View Details
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																			<td
																				width="10"
																				style={{
																					width: '10px',
																					fontSize: '1px',
																					lineHeight: '1px'
																				}}
																			></td>
																			<td
																				width="140"
																				className="product-card"
																				style={{ width: '140px' }}
																			>
																				<a
																					href="/dashboard/v1"
																					style={{ display: 'block' }}
																				>
																					<img
																						src="/color-admin/admin/react/assets/img/mailbox/img-4.png"
																						width="100%"
																						alt="Email templates preview"
																						style={{
																							width: '100%',
																							maxWidth: '100%',
																							border: '0',
																							display: 'block',
																							margin: '0 0 15px'
																						}}
																					/>
																				</a>
																				<h5
																					style={{
																						color: '#2d353c',
																						fontSize: '15px',
																						lineHeight: '21px',
																						fontWeight: 'bold',
																						margin: '0',
																						display: 'block'
																					}}
																				>
																					Email Templates
																				</h5>
																				<p
																					style={{
																						color: '#4b5563',
																						fontSize: '12px',
																						lineHeight: '16px',
																						margin: '0 0 10px'
																					}}
																				>
																					Responsive notification and
																					newsletter layouts for customer
																					messaging.
																				</p>
																				<table
																					className="btn blue"
																					cellPadding="0"
																					cellSpacing="0"
																				>
																					<tbody>
																						<tr>
																							<td
																								style={{
																									background:
																										'#0F83F0',
																									padding:
																																																'6px 12px',
																									textAlign: 'center'
																								}}
																							>
																								<a
																									href="#/"
																									style={{
																										color: '#2d353c',
																										fontSize:
																											'12px',
																										fontWeight:
																											'bold',
																										textDecoration:
																											'none'
																									}}
																								>
																									View Details
																								</a>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
												<table className="divider"></table>
											</td>
										</tr>
									</tbody>
								</table>
								<table className="row footer">
									<tbody>
										<tr>
											<td className="center" align="center">
												<center>
													<table className="container">
														<tbody>
															<tr>
																<td className="wrapper">
																	<table className="four columns">
																		<tbody>
																			<tr>
																				<td> © SeanTheme 2026. </td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
																<td className="wrapper">
																	<table className="eight columns">
																		<tbody>
																			<tr>
																				<td className="wrapper text-end valign-middle">
																					<a
																						href="#/"
																						style={{ color: '#333333', marginRight: '1rem' }}
																					>
																						Unsubscribe
																					</a>
																					<a
																						href="#/"
																						style={{ color: '#333333', marginRight: '1rem' }}
																					>
																						About Us
																					</a>
																					<a
																						href="#/"
																						style={{ color: '#333333', marginRight: '1rem' }}
																					>
																						Privacy Policy
																					</a>
																					<a
																						href="#/"
																						style={{ color: '#333333' }}
																					>
																						Terms of Use
																					</a>
																				</td>
																				<td className="expander"></td>
																			</tr>
																		</tbody>
																	</table>
																</td>
															</tr>
														</tbody>
													</table>
												</center>
											</td>
										</tr>
									</tbody>
								</table>
							</center>
						</td>
					</tr>
				</tbody>
			</table>
		</>
	);
}

function EmailNewsletterPage() {
	useEffect(() => {
		document.body.classList.add('email-page');
		return () => document.body.classList.remove('email-page');
	}, []);

	return (
		<div className="email-template-page">
			<EmailNewsletter />
		</div>
	);
}

export default EmailNewsletterPage;
